import React from 'react'

import { Container } from './styles'

export interface ModalBodyProps {
  className?: string
  padded?: boolean
  centered?: boolean
  children?: React.ReactNode
}

export const ModalBody = ({
  className,
  children,
  padded = true,
  centered = false,
}: ModalBodyProps) => {
  return (
    <Container className={className} padded={padded} centered={centered}>
      {children}
    </Container>
  )
}
